<template>
  <section
    class="component-a5e7ae66"
    resmed-component-name="product_feature_block_icon-line_text_3graphics"
    v-bind:style="{
      'background-image': `url(${acf.layout['background-image']})`,
      'background-color': acf.layout['background-color'],
    }"
  >
    <div class="component">
      <div class="container px-xs-sm-2 pt-6 pb-4">
        <div class="row justify-content-center">
          <div class="col-md-10 text-center">
            <eyebrow-icon
              v-if="acf.eyebrowicon"
              v-bind:eyebrowicon="acf.eyebrowicon"
              v-bind:align="'center'"
            ></eyebrow-icon>
            <h4 v-html="acf.headline"></h4>
          </div>
        </div>
        <div v-if="acf.items" class="items text-center">
          <div class="item" v-for="item in acf.items">
            <figure>
              <img class="img-fluid" v-bind:src="`${item.icon}`" alt="" />
            </figure>
            <p v-html="item.description"></p>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "component-a5e7ae66", // product_feature_block_icon-line_text_3graphics
  props: ["acf"],
};
</script>

<style lang="scss" scoped>
@import "../../css/abstracts/path";
@import "../../css/abstracts/colors";
@import "../../css/base/typography";

.component-a5e7ae66 {
  padding: 6rem 0 5rem 0;
  background-size: cover;
  background-position: center top;
  background-repeat: no-repeat;
  margin-bottom: -12rem;
}

.component {
  h4 {
    position: relative;
    margin: 0;

    @extend %eyebrow-center;
  }

  .container {
    background: $cc-resmed-white;
    box-shadow: -3px 0.875rem 12px 0 rgba(0, 0, 0, 0.125);
    border-radius: 6px;
    transform: translateY(-9rem);

    @media (max-width: 575px) {
      max-width: 80vw;
    }
  }

  .items {
    @media (min-width: 768px) {
      display: flex;
      justify-content: center;
    }

    .item {
      padding: 2rem 3rem 1rem 3rem;

      @media (max-width: 767px) {
        margin: 0 auto;
      }

      @media (min-width: 768px) {
        width: 33.333%;
      }

      @media (min-width: 1200px) {
        min-width: 320px;
      }

      figure {
        margin: 0 auto 0.75rem auto;

        img {
          margin: 0 auto;
          display: block;
          width: 4.5rem;
          height: 4.5rem;
        }
      }
    }
  }
}
</style>